import { render } from "./noticeAdd.vue?vue&type=template&id=398a431f&scoped=true"
import script from "./noticeAdd.vue?vue&type=script&lang=js"
export * from "./noticeAdd.vue?vue&type=script&lang=js"

import "./noticeAdd.vue?vue&type=style&index=0&id=398a431f&lang=css"
import "./noticeAdd.vue?vue&type=style&index=1&id=398a431f&lang=css"
import "./noticeAdd.vue?vue&type=style&index=2&id=398a431f&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398a431f"]])

export default __exports__